/**
 * Wraps the backend / ajax lib for better centralizing
 * common interceptions.
 */

import axios, { AxiosInstance, AxiosRequestHeaders, CancelTokenSource, InternalAxiosRequestConfig } from 'axios';
import { getCsrfToken } from '@/helpers/auth';
import { appUrl } from '@/helpers/globals';

let _instance: AxiosInstance | null = null;
/**
 * Interceptor for the CSRF token: Each request
 * is enhanced with the CSRF token stored in localStorage
 * @param {Object} config
 */
export const csrfInterceptor = (
    config: InternalAxiosRequestConfig & { xsrfHeaderName?: string; headers?: { [key: string]: any } },
): InternalAxiosRequestConfig & { xsrfHeaderName?: string } => {
    const token = getCsrfToken();
    if (!config.headers) {
        config.headers = {} as AxiosRequestHeaders;
    }
    if (token) {
        config.headers[config.xsrfHeaderName || ''] = getCsrfToken();
    } else {
        delete config.headers[config.xsrfHeaderName || ''];
    }
    return config;
};

export const sessionTimeoutInterceptor = (error: any) => {
    // Ignore axios cancellations:
    if (axios.isCancel(error)) {
        return;
    }
    // ... or else!
    if (error.response.status === 401) {
        window.alert('Die Session ist abgelaufen, bitte erneut anmelden.');
        const fromUrl = window.location.href;
        window.location.href = appUrl('/login', { redirect: encodeURIComponent(fromUrl) });
    } else {
        throw error;
    }
};

axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.request.use(csrfInterceptor);
axios.interceptors.response.use((response) => response, sessionTimeoutInterceptor);

// async function loadAuthInfo(baseURL) {
//     let res = await axios.get('/auth/sessionInfo', {
//         baseURL
//     });
//     return res.data;
// }

function init(opts: { baseURL?: string }) {
    _instance = axios.create({
        baseURL: opts.baseURL,
        timeout: 30000,
    });
    _instance.interceptors.request.use(csrfInterceptor);
    _instance.interceptors.response.use((response) => response, sessionTimeoutInterceptor);
    return _instance;
}

export function instance() {
    if (!_instance) {
        throw new Error('API not initialized. Use init() first.');
    }
    return _instance;
}

export function getTokenSource(): CancelTokenSource {
    return axios.CancelToken.source();
}

export function getBaseURL() {
    return instance().defaults.baseURL;
}

export default {
    // loadAuthInfo,
    init,
    instance,
    getTokenSource,
};
